import { Redirect, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

import {
  getActiveLanguage,
  getHomepageEditPath,
  getLanguageHomePath,
} from '../../helpers/homepageUrl';

const RedirectHomepageEdit = () => {
  const { pathname } = useLocation();
  const locale = useSelector((state) => state.intl.locale);
  const language = getActiveLanguage(pathname, locale);
  const homePath = getLanguageHomePath(language);
  const editPath = getHomepageEditPath(language);

  return (
    <Redirect to={`${editPath}?return_url=${encodeURIComponent(homePath)}`} />
  );
};

export default RedirectHomepageEdit;
